module.exports = __webpack_public_path__ + "img/user.d9ed8eec.png";